export default {
  'reopen': [ 1, 2, 3 ], // name of functionality and array of permissionLevels
  'edit_quotes': [ 1 ],
  'edit_customer': [ 1, 2, 3 ],


}



// WEBPACK FOOTER //
// ./src/config/funcPermissions.js